var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('iframe',{staticClass:"policy-iframe",attrs:{"src":"https://keda.kwai.com/pages/187/ca4cda50?env=1&isPc=1"}})
}
var staticRenderFns = []

export { render, staticRenderFns }